import { combineReducers } from "redux"
import productAdding from "./AddProduct/reducer"
import ForgetPassword from "./auth/forgetpwd/reducer"
// Authentication
import Login from "./auth/login/reducer"
import Profile from "./auth/profile/reducer"
import Account from "./auth/register/reducer"
//Calendar
import calendar from "./calendar/reducer"
//chat
import chat from "./chat/reducer"
//contacts
import contacts from "./contacts/reducer"
//crypto
import crypto from "./crypto/reducer"
//Dasboard saas
import DashboardSaas from "./dashboard-saas/reducer"
//Dashboard
import Dashboard from "./dashboard/reducer"
//E-commerce
import ecommerce from "./e-commerce/reducer"
//invoices
import invoices from "./invoices/reducer"
// Front
import Layout from "./layout/reducer"
//mails
import mails from "./mails/reducer"
//projects
import projects from "./projects/reducer"
//tasks
import tasks from "./tasks/reducer"

import customer from "./e-commerce/reducer"

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Account,
  ForgetPassword,
  Profile,
  ecommerce,
  calendar,
  chat,
  mails,
  crypto,
  invoices,
  projects,
  tasks,
  contacts,
  Dashboard,
  DashboardSaas,
  productAdding,
  customer,
})

export default rootReducer
